const schoolsList = [
    {
        imagesrc: "/tcu.jpg",
        name:"Texas Christian University",
        location: "Fort Worth, Texas",
        degree: "Bachelor of Science",
        major: "Computer Science",
        minor: "Mathematics",
        gpa: "3.6/4.0",
        honor: "Upsilon Pi Epsilon (UPE), Vietnamese Student Association (VSA), TCU Harry Potter Club, Computer Science Society (CSS)"
    },
    // {
    //     imagesrc: "/Drake.jpg",
    //     name:"Tran Phu gifted highschool",
    //     location: "Hai Phong, Vietnam",
    //     degree: "N/A",
    //     major: "Mathematics",
    //     minor: "N/A",
    //     gpa: "9.2/10.0",
    //     honor: "Informatic Technology team, Gender Equality Raising Soccer (GERS), Tran Phu Football Club (TPCFC)"
    // }
]

export default schoolsList;